<script lang="ts" setup>

const props = defineProps<{
  description: string,
  title: string,
  items: {
    title: string,
    description: string
  }[],
  addBackground: boolean
}>();

</script>
<template>
  <div :class="`container-fluid accordion-div ${addBackground ? 'bg-secondary' : ''}`">
    <div class="container-xl">
      <div class="row">
        <div class="col-12 col-lg-4 pe-4 pt-2">
          <h1 class="mb-4 text-dark-2 w-50" v-html="props.title"/>
          <div v-html="props.description"></div>
        </div>
        <div class="col-12 col-lg-8 mt-3 mt-md-0">
          <div class="accordion" id="accordion">
            <template v-for="(item,index) in props.items">
              <div class="accordion-item border-0 bg-transparent">
                <div :class="`${index === (props.items.length-1) ? '' : 'mb-4'} accordion-header rounded-pill border-0 ${addBackground ? 'bg-white' : 'bg-secondary'}`">
                  <button class="accordion-button py-4 px-4 shadow-none bg-transparent collapsed" type="button"
                          data-bs-toggle="collapse" :data-bs-target="`#collapsible-item-${index}`"
                          aria-expanded="false" aria-controls="flush-collapseOne">
                   <span class="text-primary mb-0">{{ item.title }}</span>
                  </button>
                </div>
                <div :id="`collapsible-item-${index}`" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div :class="`${index === (props.items.length-1) ? 'pt-4' : 'pt-0'} accordion-body pb-4`" v-html="item?.description"></div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
